import { useCurrentApplication } from 'application/hooks/useCurrentApplication';
import { useOrganization } from 'hooks/useOrganization';

export function useCurrentOrganization() {
  const { data: currentApp } = useCurrentApplication();
  return useOrganization(currentApp?.organization_id);
}
